import { __awaiter } from "tslib";
import { computed, defineComponent, ref, watch, inject } from 'vue';
import { useStore } from 'vuex';
import { Actions as SchemaActions } from '@/store/enums/hrgs/master/SchemaEnum';
import { Actions as AssessmentActions } from '@/store/enums/hrgs/master/AssessmentEnum';
import { validationRequired } from '@/core/helpers/validation';
import { Actions as UserActions } from '@/store/enums/hrgs/master/UserEnum';
import { useRoute } from 'vue-router';
export default defineComponent({
    props: {
        disabled: Boolean
    },
    setup() {
        const route = useRoute();
        const store = useStore();
        const employeeID = computed(() => {
            return store.getters.currentUser.employeeID;
        });
        const schemaOptions = ref([]);
        const assessmentDestinationOptions = ref([]);
        watch(employeeID, (value) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            if (value) {
                const myUserPosition = yield store.dispatch(UserActions.GET_USER_POSITION);
                const payload = {
                    pageSize: 9999
                };
                const result = yield Promise.allSettled([
                    store.dispatch(SchemaActions.GET_LIST, Object.assign(Object.assign({}, payload), (route.query.tab === 'myassessment' && {
                        positionId: (_b = (_a = myUserPosition === null || myUserPosition === void 0 ? void 0 : myUserPosition.content) === null || _a === void 0 ? void 0 : _a.position) === null || _b === void 0 ? void 0 : _b.id
                    }))),
                    store.dispatch(AssessmentActions.GET_PURPOSE_LIST, payload)
                ]);
                schemaOptions.value = (_c = result[0].value) === null || _c === void 0 ? void 0 : _c.map((item) => {
                    return {
                        label: item.title,
                        value: item.id
                    };
                });
                assessmentDestinationOptions.value = (_d = result[1].value) === null || _d === void 0 ? void 0 : _d.map((item) => {
                    return {
                        label: item.name,
                        value: item.id
                    };
                });
            }
        }), {
            immediate: true
        });
        const formData = ref({
            schemeId: '',
            assessmentPurposeId: ''
        });
        // inject data from Form component on Assessment for reactive v-model binding form (i'm changing modelValue ref)
        const form = inject('form');
        const schemeId = computed(() => {
            if (form)
                return form.schemeId;
            return formData.value.schemeId;
        });
        const assessmentPurposeId = computed(() => {
            if (form)
                return form.assessmentPurposeId;
            return formData.value.assessmentPurposeId;
        });
        const dataList = ref([]);
        const changeSchemeId = (item) => __awaiter(this, void 0, void 0, function* () {
            if (item) {
                const result = yield store.dispatch(SchemaActions.GET_DETAIL, {
                    id: item.value
                });
                dataList.value = result.competencyUnits;
            }
        });
        watch(form, (value) => __awaiter(this, void 0, void 0, function* () {
            if (value && value.schemeId) {
                const result = yield store.dispatch(SchemaActions.GET_DETAIL, {
                    id: value.schemeId
                });
                dataList.value = result.competencyUnits;
            }
        }), {
            immediate: true
        });
        return {
            validationRequired,
            schemaOptions,
            assessmentDestinationOptions,
            formData,
            form,
            dataList,
            changeSchemeId,
            schemeId,
            assessmentPurposeId
        };
    }
});
